import React from "react";
import "./variety-region-master.styles.css";
import { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserData ,selectMSMessageRBAC} from "../../redux/user/user.selectors";
import { canUserEdit ,getUserMSRBACMessage} from "../../auth/utils";
import { FeatureCodes } from "../../auth/data";
import {
  Table,
  Spin,
  Input,
  Select,
  Button,
  message,
  Form,
  Modal,
  Radio,
} from "antd";

import API from "../../api";
const { Search } = Input;
const { Option } = Select;
/**
 * @description Component for user management tab
 *
 * @component
 */
class VarietyRegionMaster extends Component {
  state = {
    isModalVisible: false,
    isAdd: false,
    currentRecord: null,
    userBranches: null,
    searchText: null,
    searchUserType: 0,
    varietyRegionTableData: [],
    regionList: [],
    mandiRegionList: [],
    varietyList: [],
    hubRegionList: [],
    hubBranchList: [],
    isSpinnerOnLoad: false,
    isSubmitted: false,
    newData: {
      is_active: true,
      pk_id: undefined,
      region_id: undefined,
      region_name: "",
      variety_id: undefined,
      variety_name: "",
      isEdit: false,
    },
    rowData: undefined,
    selectedRoleValue: undefined,
    selectedRoleName: "",
    selectedvarietyList: [],
  };
  componentDidMount() {
    this.setState({ isSpinnerOnLoad: true });
    this.getvarietyList();
    this.getRegionList();
  }

  getvarietyList = async () => {
    this.setState({ isSpinnerOnLoad: true });

    //TODO: change api
    await API.get("/list_variety")
      .then((roleData) => {
        this.setState(
          {
            varietyList: roleData.data.data,
          },
          () => this.getVarietyRegionMaster()
        );
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  getRegionList = async () => {

    //TODO: change api
    await API.get("/list_region")
      .then((roleData) => {
        this.setState(
          {
            regionList: roleData.data.data,
          },
        );
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  getVarietyRegionMaster = async () => {
    this.setState({ isSpinnerOnLoad: true });


    await API.get("/master_variety_region")
      .then((varietyResponse) => {

        varietyResponse.data.data.map((dataDetailItem, index) => {
          dataDetailItem.key = index;
          dataDetailItem.isEdit = false;
        });
        this.setState(
          {
            // varietyRegionTableData: [],
            varietyRegionTableData: varietyResponse.data.data,
          },
          () => this.setState({ isSpinnerOnLoad: false, isAdd: true })
        );

      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
          else {
            message.error("Something went wrong.. Please try again later.", 5);
          }
        } else {
          message.error("Something went wrong... Please try again later.", 5);
        }
        this.setState({ isSpinnerOnLoad: false });
      });
  };

  setTableData = () => {
    if (this.state.varietyRegionTableData !== undefined || this.state.varietyRegionTableData.length >= 0) {
      const userTableData = this.state.varietyRegionTableData.map((user, index) => {
        return {
          key: user.key,
          is_active: user.is_active,
          pk_id: user.pk_id,
          region_id: user.region_id,
          region_name: user.region_name,
          variety_id: user.variety_id,
          variety_name: user.variety_name,

          isEdit: user.isEdit,
        };
      });

      let dataAfterSearch = userTableData;

      if (this.state.searchText) {
        dataAfterSearch = dataAfterSearch.filter(
          (item) =>
            (item.variety_name !== null &&
              item.variety_name
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase())) ||
            (item.region_name !== null &&
              item.region_name
                .toLowerCase()
                .includes(this.state.searchText.toLowerCase()))
          // (item.hub_name !== null &&
          //   item.hub_name
          //     .toLowerCase()
          //     .includes(this.state.searchText.toLowerCase())) 
        );
      }

      return dataAfterSearch;
    }
    else {
      return this.state.varietyRegionTableData;
    }
  };

  submitTableRowData = (row, index, isPopup) => {
    this.setState({ isSpinnerOnLoad: true, isSubmitted: true });
    let warningmessage = "";
    if (row.variety_name === null || row.variety_name === undefined || row.variety_name === "") {
      warningmessage = "Please select variety";
    }
    else if (row.region_name === null || row.region_name === undefined || row.region_name === "") {
      warningmessage = "Please select region";
    }

    if (
      warningmessage === "" ||
      warningmessage === undefined ||
      warningmessage === null
    ) {
      this.setState({ isSpinnerOnLoad: true });
      this.setState({ isSubmitted: true })
      let data = {
        pk_id: row.pk_id,
        region_id: row.region_id,
        region_name: row.region_name,
        variety_id: row.variety_id,
        variety_name: row.variety_name
      };



      API.put("/master_variety_region", data, {

      })
        .then((response) => {
          if (response.status === 200 && response.data.status) {
            message.info(response.data.message, 5);
            this.setModalVisibility(false);
            this.getVarietyRegionMaster();
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          } else if (!response.data.status) {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error(response.data.message, 5);
            // this.setModalVisibility(false);
          } else {
            this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
            message.error("Please try again", 5);
          }
        })
        .catch((err) => {
          if (err) {
            if (err.response && err.response.status === 400) message.error("Something went wrong. Please try again later.", 5);
            else {
              message.error("Something went wrong.. Please try again later.", 5);
            }
          } else {
            message.error("Something went wrong... Please try again later.", 5);
          }
          this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
          // this.setModalVisibility(false);
        });
    } else {
      this.setState({ isSpinnerOnLoad: false, isSubmitted: false });
      message.error(warningmessage, 5);
    }
  };

  setModalVisibility = (status) => {
    if (status) {
      const nData = {
        is_active: true,
        pk_id: undefined,
        region_id: undefined,
        region_name: "",
        variety_id: undefined,
        variety_name: "",
        isEdit: false,
      };

      this.setState({ newData: nData });
    }

    this.setState({ isModalVisible: status });
  };

  TableColumnHeader = (props) => {
    const { title, subtitle } = props;
    return (
      <div className="column-header-container">
        <div
          style={{
            color: "white",
            fontSize: "12px",
            whiteSpace: "nowrap",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "11px",
            fontWeight: "normal",
            textAlign: "left",
            // subtitle && title.length < subtitle.length ? "left" : "center"
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };

  createFilters = (label) => {
    let filterData = this.state.varietyRegionTableData;
    //#region remove duplicate objects
    let uniqueFilterData = [];

    if (
      label === "is_active" &&
      this.state.varietyRegionTableData &&
      this.state.varietyRegionTableData.length > 0
    ) {
      uniqueFilterData = [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ];
    } else {
      filterData.map((mainItem) =>
        uniqueFilterData.filter((item) => item[label] === mainItem[label])
          .length > 0
          ? null
          : uniqueFilterData.push(mainItem)
      );

      uniqueFilterData = uniqueFilterData.map((item) => {
        return {
          text: item[label],
          value: item[label],
        };
      });

      uniqueFilterData.sort((a, b) => a.text.localeCompare(b.text));
    }

    return uniqueFilterData;
  };

  handleChange = (e, row, index, name, isPopup) => {
    e.target.name = name;

    var alphaNumericRegex = /^[a-zA-Z0-9]*$/;
    var numberRegex = /^[0-9.]+$/;
    let a;

    if (isPopup === false) {
      a = this.state.varietyRegionTableData;

      //   if (e.target.name === "M_H_Freight") {
      //     if (e.target.value === "") {
      //       a[row.key].M_H_Freight = "";
      //     } else if (e.target.value.match(numberRegex)) {
      //       a[row.key].M_H_Freight = e.target.value;
      //     }
      //   }

      this.setState({ varietyRegionTableData: a });
    } else {
      a = this.state.newData;

      //   if (
      //     e.target.name === "M_H_Freight") {
      //     if (e.target.value === "") {
      //       a.M_H_Freight = "";
      //     } else if (e.target.value.match(numberRegex)) {
      //       a.M_H_Freight = e.target.value;
      //     }
      //   }

      this.setState({ newData: a });
    }
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  handleEditChange = (row, index) => {
    this.setState({ rowData: row });
    let tempData = this.state.varietyRegionTableData.map((item) => {

      if (item.key === row.key) {
        return {
          ...item,
          isEdit: true
        }
      } else {
        return item;
      }
    })
    this.setState({ varietyRegionTableData: tempData });
  };

  handleCancelClick = (rowData, index) => {
    let tempData = this.state.varietyRegionTableData.map((item) => {
      if (item.key === rowData.key) {
        return this.state.rowData
      } else {
        return item;
      }
    })
    this.setState({ varietyRegionTableData: tempData });
  };

  handleDropdownChange = (value, row, target, index, optionlabel, isPopup) => {

    let a;

    if (isPopup === false) {
      a = this.state.varietyRegionTableData;

      if (target === "variety_name") {
        a[row.key].variety_name = optionlabel;
        a[row.key].variety_id = value;
      }
      else if (target === "region_name") {
        a[row.key].region_id = value;
        a[row.key].region_name = optionlabel;
      }

      this.setState({ varietyRegionTableData: a });
    } else {
      a = this.state.newData;

      if (target === "variety_name") {
        a.variety_name = optionlabel;
        a.variety_id = value;
      }
      else if (target === "region_name") {
        a.region_id = value;
        a.region_name = optionlabel;
      }

      this.setState({ newData: a });
    }
  };

  render() {
    const userTableProps = {
      pagination: false,
      size: "default",
      bordered: true,
      scroll: { x: 200, y: window.innerHeight - 250 },
    };

    const handleRoleSelect = (value, props) => {
      this.setState(
        { selectedRoleName: props.key, selectedRoleValue: value },
        () => this.getVarietyRegionMaster()
      );
    };

    return (
      <div
        className="mandi-master-container"
        style={{
          height: window.innerHeight - 85,
          marginTop: "-45px",
        }}
      >
        <div className="top-container">



          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              placeItems: "flex-end",
              marginRight: "25px",
              marginBottom: "10px",
            }}
          >
            <Search
              disabled={!this.state.isAdd}
              placeholder="Search"
              allowClear
              onChange={(e) => this.setState({ searchText: e.target.value })}
              style={{ width: "25%" }}
            />
            <Button
              className="add-master-button"
              style={{
                height: "25px",
                width: "70px",
                backgroundColor: "#0b133d",
                color: "white",
              }}
              disabled={ !canUserEdit(
                this.props.userData,
                null,
                FeatureCodes.MS_VARIETY_REGION_MAP_EDIT
              ) || !this.state.isAdd}
              onClick={() => this.setModalVisibility(true)}
            >
              &#10010; Add
            </Button>
          </div>
        </div>

        <div>
        <div
        style={{
          marginLeft: "25px",
          marginTop: "-8px",
          fontSize: "14px",
          color: "red",
          display: "flex",
          float: "left",
        }}
      > {getUserMSRBACMessage(this.props.messageAccess,FeatureCodes.MS_VARIETY_REGION_MAP_EDIT)}
      </div>
        <div
          style={{
            marginRight: "20px",
            marginTop: "-8px",
            fontSize: "15px",
            color: "#0B133D",
            display: "flex",
            float: "right",
          }}
        >Total number of records:&nbsp;
          <b>{this.state.varietyRegionTableData && this.setTableData().length}</b>
        </div>
        </div>

        <Spin
          spinning={this.state.isSpinnerOnLoad}
          size={"large"}
          tip="Loading..."
          style={{ alignSelf: "center", zIndex: 9999, marginTop: "20px" }}
        >
          <Modal
            className="add-master-modal"
            title={"Add Variety region mapping"}
            onCancel={this.handleCancel}
            footer={false}
            visible={this.state.isModalVisible}
            destroyOnClose={true}
          >
            <div className="master-form-container">
              <Form
                layout="horizontal"
                //   onValuesChange={onFormLayoutChange}
                size={"small"}
              // onSubmit={submitTableRowData(this.state.newData)}
              >
                <div className="form-top-container1">
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "55%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Variety">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="variety_name"
                        defaultValue={this.state.newData.variety_name}
                        value={this.state.newData.variety_name}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "variety_name",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.varietyList &&
                          this.state.varietyList.length &&
                          this.state.varietyList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.variety_id}
                              value={hubItem.variety_id}
                            >
                              {hubItem.variety_name}
                            </Option>
                          ))}
                      </Select>

                    </Form.Item>
                  </div>
                  <div
                    className="checkbox-group1"
                    style={{
                      display: "inline-block",
                      width: "55%",
                      marginRight: 40,
                    }}
                  >
                    <Form.Item label="Region">
                      <Select
                        showSearch
                        optionFilterProp="children"
                        className="remarks-select"
                        name="region_name"
                        defaultValue={this.state.newData.region_name}
                        value={this.state.newData.region_name}
                        onSelect={(value, option) =>
                          this.handleDropdownChange(
                            value,
                            this.state.newData,
                            "region_name",
                            -0,
                            option.props.children,
                            true
                          )
                        }
                      >
                        {this.state.regionList &&
                          this.state.regionList.length &&
                          this.state.regionList.map((hubItem, idx) => (
                            <Option
                              key={hubItem.region_id}
                              value={hubItem.region_id}
                            >
                              {hubItem.region_name}
                            </Option>
                          ))}
                      </Select>

                    </Form.Item>

                  </div>
                </div>

                <div className="form-bottom-container">
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={this.state.isSubmitted}
                      onClick={() =>
                        this.submitTableRowData(this.state.newData, 0, true)
                      }
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Modal>


          <div className="table-container1" style={{ maxHeight: "450px", width: "99%", margin: "6px 0px" }}>
            <Table
              {...userTableProps}
              columns={[
                {
                  title: "Variety",
                  dataIndex: "variety_name",
                  key: "variety_name",
                  width: 130,
                  filters: this.createFilters("variety_name"),
                  onFilter: (value, record) => record.variety_name.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.variety_name.localeCompare(b.variety_name),
                  // render: (record, rowRecord, index) => {
                  //   return (
                  //     <>
                  //       <div
                  //         style={{ marginLeft: "-15px", marginRight: "-10px" }}
                  //       >
                  //         <Select
                  //           className="remarks-select"
                  //           showSearch
                  //           optionFilterProp="children"
                  //           disabled={!rowRecord.isEdit}
                  //           name="variety_name"
                  //           defaultValue={rowRecord.variety_name}
                  //           value={rowRecord.variety_name}
                  //           onSelect={(value, option) =>
                  //             this.handleDropdownChange(
                  //               value,
                  //               rowRecord,
                  //               "variety_name",
                  //               index,
                  //               option.props.children,
                  //               false
                  //             )
                  //           }
                  //         >
                  //           {this.state.varietyList &&
                  //             this.state.varietyList.length &&
                  //             this.state.varietyList.map((hubItem, idx) => (
                  //               <Option
                  //                 key={hubItem.variety_id}
                  //                 value={hubItem.variety_id}
                  //               >
                  //                 {hubItem.variety_name}
                  //               </Option>
                  //             ))}
                  //         </Select>
                  //       </div>
                  //     </>
                  //   );
                  // },
                },
                {
                  key: "region_name",
                  title: "Region",
                  dataIndex: "region_name",
                  width: 130,
                  filters: this.createFilters("region_name"),
                  onFilter: (value, record) => record.region_name.includes(value),
                  sortDirections: ["descend", "ascend"],
                  sorter: (a, b) => a.region_name.localeCompare(b.region_name),
                  // render: (record, rowRecord, index) => {
                  //     return (
                  //       <>
                  //         <div
                  //           style={{ marginLeft: "-15px", marginRight: "-10px" }}
                  //         >
                  //           <Select
                  //             className="remarks-select"
                  //             showSearch
                  //             optionFilterProp="children"
                  //             disabled={!rowRecord.isEdit}
                  //             name="region_name"
                  //             defaultValue={rowRecord.region_name}
                  //             value={rowRecord.region_name}
                  //             onSelect={(value, option) =>
                  //               this.handleDropdownChange(
                  //                 value,
                  //                 rowRecord,
                  //                 "region_name",
                  //                 index,
                  //                 option.props.children,
                  //                 false
                  //               )
                  //             }
                  //           >
                  //             {this.state.regionList &&
                  //               this.state.regionList.length &&
                  //               this.state.regionList.map((hubItem, idx) => (
                  //                 <Option
                  //                   key={hubItem.region_id}
                  //                   value={hubItem.region_id}
                  //                 >
                  //                   {hubItem.region_name}
                  //                 </Option>
                  //               ))}
                  //           </Select>
                  //         </div>
                  //       </>
                  //     );
                  //   },
                },
                // {
                //   title: "Action",
                //   dataIndex: "Submit",
                //   key: "Submit",
                //   width: 90,
                //   visibility: false,
                //   render: (record, rowRecord, index) => {
                //     return (
                //       <>
                //         <div style={{ display: "inline-flex", width: "100%" }}>
                //           <Button
                //             className={
                //               rowRecord.surplus_deficit <= 0
                //                 ? "disable-edit-btn"
                //                 : "edit-btn"
                //             }
                //             type="primary"
                //             size={"small"}
                //             style={{
                //               marginLeft: 5,
                //               alignSelf: "center",
                //               padding: "0px 0px 2px",
                //               height: 31,
                //               backgroundColor: "#20346a",
                //               color: "white",
                //               borderRadius: 15,
                //             }}
                //             block
                //             htmlType="submit"
                //             onClick={() =>
                //               rowRecord.isEdit
                //                 ? this.submitTableRowData(rowRecord, index, false)
                //                 : this.handleEditChange(rowRecord, index)
                //             }
                //           >
                //             {" "}
                //             {rowRecord.isEdit ? "Submit" : "Edit"}{" "}
                //           </Button>


                //           <Button
                //             className={!rowRecord.isEdit ? "disabledBtnClass" : "btnClass"}
                //             type="primary"
                //             size={"small"}
                //             style={{
                //               marginLeft: 5,
                //               alignSelf: "center",
                //               color: "white",
                //               borderRadius: 15,
                //               padding: "0px 0px 2px",
                //               height: 31,
                //               backgroundColor: "#20346a",
                //             }}
                //             block
                //             htmlType="submit"
                //             disabled={!rowRecord.isEdit}
                //             onClick={() => this.handleCancelClick(rowRecord, index)
                //             }
                //           >
                //             Cancel
                //         </Button>

                //         </div>
                //       </>
                //     );
                //   },
                // },
              ]}
              dataSource={this.setTableData()}
            />
          </div>

        </Spin>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  messageAccess: selectMSMessageRBAC,
});
export default connect(mapStateToProps)(VarietyRegionMaster);
//export default VarietyRegionMaster;
